import { GET_ZIP_VALUE } from '@/housefolios-components/TitleButtons/AddPropertyButton/queries'

import {
  padStart,
  truncate,
  map,
  isArray,
  isNil,
} from '@/utils/lodash'

/** GraphQL [Int]/[Float] reject ""; coerce blank unit values to 0. */
export const toNumericUnitArray = (values, asInt = false) => {
  if (isNil(values)) return [0]
  return map(isArray(values) ? values : [values], (value) => {
    if (value === '' || value === null || value === undefined) return 0
    const parsed = asInt ? parseInt(value, 10) : parseFloat(value)
    return Number.isFinite(parsed) ? parsed : 0
  })
}

export const getPropertyData = async (_client, _input) => {
  // REAPI enrichment retired — address/city/zip come from Google Places;
  // beds/baths/sqft/year are entered manually.
  return {
    propertyData: null,
    reapiPropertyData: null,
  }
}

export const getZipValues = async (client, zip) => {
  const zipResult = await client.query({
    query: GET_ZIP_VALUE,
    variables: {
      zipcode: zip
        ? padStart(
            truncate(zip, {
              length: 5,
              omission: '',
            }),
            5,
            '0',
          )
        : '',
    },
    errorPolicy: 'ignore',
  })
  const data = zipResult.data
  const error = zipResult.error
  if (error) {
    console.log(error)
  }
  const zipValues = !data ? null : data.zipValue
  return [zipValues, zipResult.loading]
}
